const sources = [
    {
        name: 'computerSetupModel',
        type: 'gltfModel',
        path: 'models/Terminal/terminal.glb',
    },
    {
        name: 'computerSetupTexture',
        type: 'texture',
        path: 'models/Terminal/baked_terminal.jpg',
    },
    {
        name: 'environmentModel',
        type: 'gltfModel',
        path: 'models/World/environment.glb',
    },
    {
        name: 'environmentTexture',
        type: 'texture',
        path: 'models/World/baked_environment.jpg',
    },
    {
        name: 'rockModel',
        type: 'gltfModel',
        path: 'models/World/rock.glb',
    },
    {
        name: 'rockTexture',
        type: 'texture',
        path: 'models/World/baked_rock.jpg',
    },
    {
        name: 'exteriorModel',
        type: 'gltfModel',
        path: 'models/World/exterior.glb',
    },
    {
        name: 'exteriorTexture',
        type: 'texture',
        path: 'models/World/baked_exterior.jpg',
    },
    {
        name: 'propsModel',
        type: 'gltfModel',
        path: 'models/Props/props.glb',
    },
    {
        name: 'propsTexture',
        type: 'texture',
        path: 'models/Props/baked_props.jpg',
    },
    {
        name: 'glassModel',
        type: 'gltfModel',
        path: 'models/Props/glass.glb',
    },
    {
        // scanlines and the darkened edges of the tube, over the monitor's page (assets/screen/make_screen_layers.py)
        name: 'screenGlassTexture',
        type: 'texture',
        path: 'monitor/glass.png',
    },
];
export default sources;
